import React, { ComponentType } from 'react';
import { useHistory } from 'react-router-dom';
import { styled } from 'theme';
import { Box, Typography } from '@mui/material';
import { SocialNetworksBox } from '../SocialNetworksBox';
import { Profile } from '../../domain';

const ClickableBox = styled(Box)({
    cursor: 'pointer',
});

const ImgCont = styled('div')<{ src: string }>(({ src }) => ({
    borderRadius: '40px',
    width: '80px',
    height: '80px',
    backgroundImage: `url(${src})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
}));

interface UserAvatarProps {
    src: string;
}

const UserPicture: ComponentType<UserAvatarProps> = ({ src }) => <ImgCont src={src}/>;
const Handler = ({ idUser, user }: { idUser: string; user: Profile }) => {
    const history = useHistory();
    const onClickHandler = () => {
        history.push(`/user/${idUser}`);
    };

    return (
        <Box
            display={'flex'}
            mb={2}
            flexDirection={'column'}
        >
            <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                {user?.picture?.url ? (
                    <ClickableBox height={'100%'} onClick={onClickHandler}>
                        <UserPicture src={user.picture.medium.url}/>
                    </ClickableBox>
                ) : null}
                <Box ml={2}>
                    <ClickableBox>
                        <Typography variant={'subtitle1'} onClick={onClickHandler}>
                            {(user.firstname || user.lastname)
                                ? `${user.firstname ?? ''} ${user.lastname ?? ''}`.trim()
                                : user.email}
                        </Typography>
                    </ClickableBox>
                </Box>
            </Box>
            <Box sx={{
                ml: {
                    sx: 0,
                    sm: 3.6
                }
            }}
            >
                <SocialNetworksBox
                    availableSocialNetworks={user?.availableSocialNetworks}
                    customSocialNetworks={user?.customSocialNetworks}
                />
            </Box>
        </Box>
    );
};
export default Handler;
